import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import {createVuetify} from "vuetify";
import {md1} from "vuetify/blueprints";

const vuetify = createVuetify({
  blueprint: md1,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'test',
    themes: {
      test: {
        colors: {
          background: '#E9ECEF',
          fusion:'#badbcb',
          input: '#e9ecef',
          green:'#198754',
          red:'#dc3545',
          orange: '#fd7e14',
          success:'#309365',
          'warning-lighten-1': '#fbc18e',
        }
      }
    }
  }
})

export default vuetify
